import { dealFormField } from '@openx/types/deal.ts';
import { PackageFields } from '@openx/types/package.ts';
import { UrlTargetingFields } from '@openx/types/targeting/domains.ts';
import { InventoryContentOption } from '@openx/types/targeting/inventoryAndContent.ts';
import { TargetingFields } from '@openx/types/targeting/targeting.ts';
import type { FieldValues, UseFormGetValues, UseFormSetValue } from 'react-hook-form';

type InventoryListPaths = {
  urlInventoryListId: string;
  appBundleInventoryList: string;
  appBundleInventoryListId: string;
};

export const getDealInventoryListPaths = (): InventoryListPaths => ({
  urlInventoryListId: `${dealFormField.TARGETING}.${PackageFields.TARGETING}.${TargetingFields.URL_TARGETING}.${UrlTargetingFields.inventorylist_id}`,
  appBundleInventoryList: `${dealFormField.TARGETING}.${PackageFields.TARGETING}.${TargetingFields.INVENTORY_AND_CONTENT}.${InventoryContentOption.APP_BUNDLE_ID}.inventorylist`,
  appBundleInventoryListId: `${dealFormField.TARGETING}.${PackageFields.TARGETING}.${TargetingFields.INVENTORY_AND_CONTENT}.${InventoryContentOption.APP_BUNDLE_ID}.inventorylist_id`,
});

export const getPackageInventoryListPaths = (): InventoryListPaths => ({
  urlInventoryListId: `${PackageFields.TARGETING}.${TargetingFields.URL_TARGETING}.${UrlTargetingFields.inventorylist_id}`,
  appBundleInventoryList: `${PackageFields.TARGETING}.${TargetingFields.INVENTORY_AND_CONTENT}.${InventoryContentOption.APP_BUNDLE_ID}.inventorylist`,
  appBundleInventoryListId: `${PackageFields.TARGETING}.${TargetingFields.INVENTORY_AND_CONTENT}.${InventoryContentOption.APP_BUNDLE_ID}.inventorylist_id`,
});

export const hasInventoryListValues = (
  getValues: UseFormGetValues<FieldValues>,
  paths: InventoryListPaths
): boolean => {
  const urlValue = getValues(paths.urlInventoryListId);
  const appBundleValue = getValues(paths.appBundleInventoryList);
  const appBundleIdValue = getValues(paths.appBundleInventoryListId);

  return !!(urlValue || appBundleValue || appBundleIdValue);
};

export const resetDealInventoryLists = (setValue: UseFormSetValue<FieldValues>): void => {
  const paths = getDealInventoryListPaths();

  setValue(paths.urlInventoryListId, null, { shouldDirty: true });
  setValue(paths.appBundleInventoryList, null, { shouldDirty: true });
  setValue(paths.appBundleInventoryListId, null, { shouldDirty: true });
};

export const resetPackageInventoryLists = (setValue: UseFormSetValue<FieldValues>): void => {
  const paths = getPackageInventoryListPaths();

  setValue(paths.urlInventoryListId, null, { shouldDirty: true });
  setValue(paths.appBundleInventoryList, null, { shouldDirty: true });
  setValue(paths.appBundleInventoryListId, null, { shouldDirty: true });
};
